import { render, staticRenderFns } from "./DonutChart49.vue?vue&type=template&id=25d7f17a&scoped=true"
import script from "./DonutChart49.vue?vue&type=script&lang=js"
export * from "./DonutChart49.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d7f17a",
  null
  
)

export default component.exports